<template>
  <div class="device-widget-bd" @click="onJumpDetails">
    <div class="ub">
      <div class="img-box">
        <img v-if="getAttachUrl(item)" :src="getAttachUrl(item)" alt="" />
        <img v-else class="gray" src="../images/logo.png" alt="" />
      </div>
      <div class="info-box ub-f1">
        <h1>{{ item.bodyNum }}</h1>
        <div class="ubw tags">
          <div v-if="item.productCode" class="biz-tag">{{ item.productCode }}</div>
          <div v-if="item.deviceName" class="biz-tag">{{ item.deviceName }}</div>
          <div v-if="item.locationName" class="biz-tag">{{ item.locationName }}</div>
          <div v-if="item.siteName" class="biz-tag">{{ item.siteName||'-' }}</div>
        </div>
        <p v-if="type == 'return'">{{ $t('deviceWidget.tui_zu_ri_qi') }}{{ momentAmPm($momentLocal(item.unbindOrgTime)) }}</p>
        <div class="ubw states" v-else>
          <!-- 电池 -->
          <div class="biz-state" v-if="item.batteryCharge || item.batteryCharge === 0">
            <i class="icon icon-a-dianliang100"></i>
            <span>{{ item.batteryCharge || item.batteryCharge === 0 ? item.batteryCharge : '-' }}%</span>
          </div>
          <!-- 信号 -->
          <div class="biz-state" v-if="(`${item.networkType}` === '1' && `${item.cellularMode}` === '1') || (`${item.networkType}` === '0' && `${item.cellularMode}` !== '1')">
            <i v-if="`${item.networkType}` === '1' && `${item.cellularMode}` === '1'" class="icon icon-wifi"></i>
            <i v-else-if="`${item.networkType}` === '0' && `${item.cellularMode}` !== '1'" class="icon icon-xinhao"></i>
            <span>{{ getDicValue('dms_device_cellular_mode', item.cellularMode) || '-' }}</span>
          </div>
          <!-- 温度 -->
          <div class="biz-state" v-if="item.batteryTemp || item.batteryTemp === 0">
            <i class="icon icon-a-wendu100"></i>
            <span>{{ $celsiusToFahrenheit(item.batteryTemp)}}{{$formatTempUnit()}}</span>
          </div>
          <div style="margin-left: 12px"></div>
          <!-- 其他状态 -->
          <div v-for="(icon, index) in statusList(item)" :key="index" class="biz-state">
            <i :class="icon.className" style="font-size: 18px; color: #93DA49"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="dit"></div>
  </div>
</template>

<script>
export default {
  props: {
    type: [String],
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted: function () {},
  methods: {
    // 设备状态
    statusList(item) {
      if (Object.keys(item).length) {
        const ret = [];
        const { lockState, isOnline, isPowerSave } = item;
        // 如果是离线状态，不显示其他实时状态(只有锁机 故障 省电)
        if (!isOnline) {
          // 显示锁机(自由锁1 账单锁2)
          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-locking gray',
              dicCode: 'isLock'
            });
          }
          // 故障
          // if (isMalfunction) {
          //   ret.push({
          //     type: 'malfunction',
          //     value: isMalfunction,
          //     className: 'icon icon-guzhang red',
          //     dicCode: 'isFault'
          //   });
          // }
          // 是否省电模式
          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave'
            });
          }
        } else {
          // 设备多状态：可以同时存在多个的状态
          /** 设备多状态 start */

          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-suoji gray',
              dicCode: 'isLock'
            });
          }
          // if (isMalfunction) {
          //   ret.push({
          //     type: 'malfunction',
          //     value: isMalfunction,
          //     className: 'icon icon-guzhang red',
          //     dicCode: 'isFault'
          //   });
          // }

          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave'
            });
          }
          /** 设备多状态 end */
        }
        return ret;
      }
      return [];
    },
    // 跳转详情
    onJumpDetails() {
      this.jump('/other/device/accountDeviceDetail', {
        bodyNum: this.item.bodyNum,
        deviceId: this.type === 'return' ? this.item.bindManualId : this.item.deviceId,
        type: this.type
      });
    }
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.device-widget-bd {
  position: relative;
  width: calc(33.3% - 7px);
  margin-bottom: 10px;
  margin-right: 10px;
  &:nth-child(3n) {
    margin-right: 0;
  }
  .dit {
    position: absolute;
    width: 10px;
    height: 10px;
    right: 16px;
    top: 16px;
    border-radius: 10px;
    &.0 {
      background-color: #b3b3b3;
    }
    &.1 {
      background-color: #00a0d9;
    }
    &.2 {
      background-color: #93da49;
    }
    &.3 {
      background-color: #ffad00;
    }
  }
  .gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
  }
  height: 108px;
  cursor: pointer;
  border: 1px solid #f5f5f5;
  box-sizing: border-box;
  border-radius: 16px;
  padding: 16px;
  &:hover {
    border-color: $--color-primary;
  }
  .img-box {
    width: 78px;
    img {
      display: block;
      width: 46px;
      height: 46px;
    }
  }
  .info-box {
    h1 {
      color: #1a1a1a;
      font-weight: bold;
      line-height: 20px;
    }
    .tags {
      margin-top: 8px;
      height: 18px;
      .biz-tag {
        height: 18px;
        line-height: 20px;
        padding: 0 6px;
        background: #f5f5f5;
        border-radius: 100px;
        margin-right: 8px;
        color: #4d4d4d;
        font-size: 12px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .states {
      margin-top: 12px;
      .biz-state {
        margin-right: 8px;
        &:last-child {
          margin-right: 0;
        }
        i.icon {
          color: #00a0d9;
          font-size: 14px;
          margin-right: 2px;
        }
        span {
          color: #202945;
          font-size: 14px;
        }
      }
    }
    p {
      margin-top: 12px;
      line-height: 18px;
      color: #202945;
      font-size: 14px;
    }
  }
}
</style>
